<template>
  <div>
    <div class="search-reference flex flex-col">
      <div class="flex flex-col justify-center p-4">
        <div class="flex items-center gap-4 max-w-[720px] md:self-center">
          <div class="flex-1 min-w-0">
            <DaysSelector
              :selected="$route.query.date"
              :showTitle="false"
              @getAvailability="handleGetAvailability"
            />
          </div>
          <div class="flex-shrink-0">
            <button
              @click="showTimeSelector = true"
              class="reference-seach px-4 py-2"
            >
              {{ time }}
            </button>
          </div>
        </div>
        <div class="flex flex-col mt-6">
          <div class="flex justify-center w-full">
            <div class="flex gap-4">
              <div class="input-component relative flex-1 min-w-[200px]">
                  <InputWhere
                    :key="inputWhereKey"
                    :placeholder="$t('search_your_clubs_cities')"
                    :addLocations="true"
                    :onlyOneSelect="true"
                    :searchTenantEnabled="true"
                    :externalSearchQuery="whereSearchQuery"
                    @tenantsLocationsSelected="handleLocationSelected"
                    @sendNearSearch="handleLocationSelected"
                    @sendFavoritesSearch="handleLocationSelected"
                    @sendTenantToBooking="handleTenantSelected"
                  />
              </div>
              <div>
                <SportButtonSelector 
                :showLabel="false"
                @sportSelected="selectSport" />
              </div>
            </div>
          </div>
        </div>
      </div>
        <MatchSuggestions 
          :filteredDataToSend="filteredDataToSend"
          :showNoResults="true"
          @hourSelected="hourSuggestionsClicked"
        />
      </div>
    <Transition>
      <PopUpLight
        v-if="createMatchMode && showGenderLevel && !isLoading"
        @closed="closeGenderLevel()"
        :customClass="'width-sm'"
        :showClose="false"
      >
        <UpdateUser
          :customSport="sport"
          @closeGenderLevel="closeGenderLevel()"
        />
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showHasGender"
        :showClose="true"
        @closed="initRedPadelLevel"
      >
        <div class="mt-8">
          <UserGenderSelector @selectionChanged="saveGenderChanges" />
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showIframe" 
        @closed="showIframe= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          <iframe class="iframe" title="redPadel login" frameborder="0" :src="iframeSrc"></iframe>
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight v-if="showRedpadelError" 
        @closed="showRedpadelError= false"
        :customClass="'width-lg'"
      >
        <div class="mt-8">
          {{ $t("oops_technical_problems_try_again_in_a_few_minutes") }}
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight
        v-if="showPopLinkPrivate"
        @closed="showPopLinkPrivate = false"
      >
        <div class="mt-5 flex justify-evenly sm:text-sm">
          <span> {{ $t("the_club_is_private") }} </span>
        </div>
      </PopUpLight>
    </Transition>
    <Transition>
      <PopUpLight
        v-if="showTimeSelector"
        @closed="showTimeSelector = false"
      >
      <div class="relative w-full input-component justify-center">
        <div class="flex flex-col mt-4 gap-3">
            <div class="flex items-center gap-4">
              <div class="font-bold">
                <TimeSelector 
                  :initialHour="time"
                  @timeSelected="selectDatepick"  
                />
              </div>
              <div class="flex items-center">
                <input
                  type="checkbox"
                  class="cursor-pointer mr-2"
                  v-model="isChecked"
                  @click="handleFlexibleSelected"
                  :class="{ selected: isChecked }"
                  id="check"
                />
                <label
                  class="text-sm cursor-pointer"
                  for="check"
                >
                  {{ flexibleStr }}
                </label>
              </div>
            </div>
            <div>
              <input
                class="search-btn sm:box-border sm:w-auto sm:flex sm:flex-row sm:justify-center sm:items-center sm:p-0 sm:h-12"
                type="button"
                :value="$t('select')"
                @click="updateTime"
              />
            </div>
          </div>
        </div>
      </PopUpLight>
    </Transition>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { defineComponent } from "vue";
import { getSearchDataToSend, getDataToBooking} from "@/helpers/dataHelper";
import { setTimeToDate, getTimeFromDateString } from "@/helpers/dateHelper";
import SportButtonSelector from "@/components/form/sportButtonSelector.vue";
import PopUpLight from "@/components/popup/popupLight.vue";
import {Category, SearchType, Sport, FLEXIBLE_HOURS} from "@/enum/constants";
import { formatDate } from "@/helpers/dateHelper";
import UpdateUser from "@/components/match/updateUser.vue";
import CustomerHelper from "@/helpers/customerHelper";
import { LevelProvider } from '@/enum/constants';
import UserGenderSelector from "@/components/form/userGenderSelector.vue";
import { useRefreshWatcher } from "@/helpers/dataHelper";
import MatchSuggestions from "@/components/match/matchSuggestions.vue"
import DaysSelector from "@/components/buttons/daysSelector.vue"
import TimeSelector from "@/components/form/inputTimeSelector.vue";
import InputWhere from "@/components/form/inputWhereSearch.vue";
import MatchHelper from "@/helpers/matchtHelper";
import { CustomerApi } from "@/service/CustomerApi";

export default defineComponent({
  components: {
    SportButtonSelector,
    PopUpLight,
    UpdateUser,
    UserGenderSelector,
    DaysSelector,
    TimeSelector,
    MatchSuggestions,
    InputWhere
  },
  data() {
    return {
      category: Category,
      showMainSearch: false,
      showFilter: false,
      selectedCategory: 0,
      responseSearchItems: null,
      dataToSend: {},
      mainSearchFormPopUpKey: 0,
      noElementsMsg: "",
      isLoading: true,
      filter: {},
      createMatchMode: false,
      sport: Sport.PADEL,
      showGenderLevel: false,
      isUserLogged: false,
      level: null,
      levelProvider: LevelProvider.PANDORA,
      hasGender: null,
      showIframe: false,
      showRedpadelError: false,
      showHasGender: false,
      iframeSrc:"",
      canCreateMatch: false,
      createMatchQuery: null,
      showPopLinkPrivate: false,
      linkTenantInfo: null,
      tenantIsPrivate: false,
      filteredDataToSend: {},
      time: "",
      selectedLocations: [],
      isChecked: false,
      showTimeSelector: false,
      flexibleStr: "",
      searchType: 0,
      whereSearchQuery: "",
      inputWhereKey:0
    };
  },
  created() {
    this.flexibleStr = this.$t("im_flexible") + FLEXIBLE_HOURS + ' ' + this.$t("hours")
    this.store = useStore();
    this.selectedCategory = Number(this.$route.query.category);
    this.searchType = Number(this.$route.query.searchType)
    if(this.searchType == SearchType.FLEXIBLE){
      this.isChecked = true
    }
    this.time = getTimeFromDateString(this.$route.query.date)
    if (this.$route.query.showSuggestions === "true") {
      this.createMatchMode = true;
    }
  },
  async mounted() {
    this.filteredDataToSend = this.setUpDataFromUrl();
    useRefreshWatcher(() => { this.handleRefresh(); });// This function will execute when the 'isRefreshed' state changes. It is passed this way because it is passed by reference.
    this.$watch("$route", (to, from) => {
      // Perform actions or checks based on the URL change
      this.sendObjectFromUrl(to.fullPath);
    });
    this.sendObjectFromUrl(window.location.href);
    this.isLoading = false;
  },
  methods: {
    selectDatepick(time) {
      this.time = time
    },
    updateTime(){
      this.showTimeSelector = false
      const currentQuery = { ...this.$route.query };
      const date = currentQuery.date
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.replace({ query: { ...this.$route.query, date: updatedDate, searchType: this.searchType} });
    },
    handleFlexibleSelected() {
      this.isChecked = !this.isChecked;
      this.searchType = this.isChecked ? SearchType.FLEXIBLE : SearchType.EXACT;
    },
    handleGetAvailability(date){
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.push({ query: { ...this.$route.query, date: updatedDate, searchType: this.searchType } });
    },
    async handleTimeSelected(time) {
      const currentQuery = { ...this.$route.query };
      const date = currentQuery.date
      this.time = time
      const updatedDate = formatDate(setTimeToDate(new Date(date), this.time))
      this.store.commit("setfullDateTime", updatedDate);
      this.$router.replace({ query: { ...this.$route.query, date: updatedDate, searchType: this.searchType } });
    },
    async hourSuggestionsClicked(data){
      this.levelProvider = MatchHelper.getLevelProviderBySport(data.defaultLevelProviders, this.$route.query.sport);
      this.tenantIsPrivate = data.private;
      this.createMatchQuery = {
          name: "createMatch",
          query: {
            id: data.tenantId,
            name: data.name,
            hour: data.hour,
            date: this.$store.state.fullDateTime,
            sport: this.$route.query.sport,
            category: Category.MATCH,
            radius: this.$route.query.radius,
            searchType: this.$route.query.searchType,
            levelProvider: this.levelProvider,
            showDateSelector: true
          },
        };
        this.linkTenantInfo = {
          tenant:{ id: data.tenantId } 
        }
        this.canCreateMatch = await this.initGenderLevel();
        if(!this.canCreateMatch){
          return;
        }
        return this.sendMatch(this.createMatchQuery);
    },
    async linkRedPadelAccount(linkLevelProvider){
      try {
        await CustomerHelper.linkLevelProviderAccount(linkLevelProvider, LevelProvider.REDPADEL);
        this.sendMatch(this.createMatchQuery);
      } catch (error) {
        this.showRedpadelError = true;
      }
    },
    async redPadelListener(event) {
      window.removeEventListener("message", this.redPadelListener);
      const resultData = event.data;
      this.showIframe = false;
      if(resultData.status){
        const linkLevelProvider = {
          accountId: resultData.user_id,
        };
        await this.linkRedPadelAccount(linkLevelProvider);
      }else{
        this.showRedpadelError = true;
      }
    },
    async saveGenderChanges(gender) {
      const user = await CustomerHelper.updateGender(gender);
      if (user) {
        CustomerHelper.updateStorageUser(user);
        this.hasGender = true;
        this.initRedPadelLevel();
      }
      this.showHasGender = false;
    },
    async initGenderLevel() {
      this.hasGender = await CustomerHelper.hasGender();
      if(!this.hasGender && this.levelProvider == LevelProvider.REDPADEL){
        this.showHasGender = true;
        return false;
      }
      this.isLoading = true;
      const hasLevel = await CustomerHelper.hasLevel(this.sport, this.levelProvider);
      this.isLoading = false;
      if((hasLevel)) {
        return true;
      }
      this.levelProvider === LevelProvider.PANDORA ? this.showGenderLevel = true : await this.initRedPadelLevel();
      return false;
    },
    async initRedPadelLevel(){
      this.showHasGender = false;
      if(this.hasGender){
        const response = await CustomerHelper.getProviderRedirectURL(LevelProvider.REDPADEL);
        if(response){
          this.iframeSrc = response.redirectURL;
          this.showIframe = true;
          window.addEventListener("message", this.redPadelListener);
        }
      }
    },
    async sendMatch(createMatchQuery){
      if(this.tenantIsPrivate){
        await this.checkPrivateClub();
      }
      if(this.canCreateMatch){
        this.$router.push(createMatchQuery);
      }
      // start link user
      return this.showPopLinkPrivate = true;
    },
    async checkPrivateClub(){
      const request = {
        tenantId: this.linkTenantInfo.tenant.id
      }
      const response = await CustomerApi.findLinkedTenantsByCustomer(request);
      if(response?.data.length > 0){
       return this.canCreateMatch = true 
      }
      return this.canCreateMatch = false
    },
    handleTenantSelected(tenant) {
      var loc = getDataToBooking(tenant);
      this.$router.replace(loc);
    },
    async selectSport(sport) {
      if (this.sport === sport) {
        return;
      }
      this.sport = sport;
      this.store.commit("setPreferencesSport", sport);
      const currentQuery = { ...this.$route.query };
      currentQuery.sport = this.sport;
      this.$router.replace({ query: currentQuery });
    },
    handleClosePopup() {
      this.closeSearch();
    },
    handleRefresh() {
      const userItem = localStorage.getItem("user");
      if (userItem != null) {
        this.mainSearchFormPopUpKey++;
      }
    },
    handleLocationSelected(selection) {
      let location = selection;
      if(Array.isArray(selection) && selection.length){
        location = selection[0]
      }
      const dataToSend = getSearchDataToSend();
      // Aux funtion to convert undefined to null
      const convertUndefinedToNull = (value) => {
        return value !== undefined ? value : null;
      };
      // Mapping all object values  to create url values
      const filteredDataToSend = Object.fromEntries(
        Object.entries(dataToSend).map(([key, value]) => [
          key,
          convertUndefinedToNull(value),
        ])
      );
      const newQuery = new URLSearchParams(window.location.search)
      delete newQuery.tenantIds;
      if(location.name){
        newQuery.set('locName', location.name)
      }
      const newUrl = `${window.location.pathname}?${newQuery.toString()}`
      window.history.replaceState({}, '', newUrl);
      this.filteredDataToSend = filteredDataToSend
    },
    openSearch() {
      this.$refs.fakeSearchBtn.blur(); // to avoid rare behavior in ios
      this.showMainSearch = true;
    },
    closeSearch() {
      this.showMainSearch = false;
    },
    async closeGenderLevel() {
       this.showGenderLevel = false;
       this.canCreateMatch = true;
       this.sendMatch(this.createMatchQuery);
    },
    async sendObjectFromUrl(url) {
      const queryString = url.substring(url.indexOf("?") + 1);
      let queryData = {};
      this.whereSearchQuery = this.$route.query.locName //add location of inputWhere
      this.inputWhereKey++; //refresh inputWhere component
      // Reconstruct tho original object
      const params = new URLSearchParams(queryString);

      for (const [key, value] of params.entries()) {
        if (Object.prototype.hasOwnProperty.call(queryData, key)) {
          if (Array.isArray(queryData[key])) {
            queryData[key].push(value !== "" ? value : null);
          } else {
            queryData[key] = [queryData[key], value !== "" ? value : null];
          }
        } else {
          queryData[key] = value !== "" ? value : null;
        }
      }
      this.filteredDataToSend = queryData;
    },
    setUpDataFromUrl() {
      const request = {
        date: this.$route.query.date,
        cordX: this.$route.query.cordX,
        cordY: this.$route.query.cordY,
        sport: this.$route.query.sport,
        category: this.$route.query.category,
        radius: this.$route.query.radius,
        searchType: +this.$route.query.searchType,
        locName: this.$route.query.locName
      };
      
      this.store.commit("setfullDateTime", request.date);
      this.store.commit("setPreferencesPlaces", [
        { cordX: request.cordX, cordY: request.cordY },
      ]);
      this.store.commit("setPreferencesSport", request.sport);
      this.store.commit("setPreferencesAction", request.category);
      this.store.commit("setSearchIsFlexible", request.searchType === SearchType.FLEXIBLE? true : false);
      return request
    },
    closePrivateLink(messageOk){
      this.showPopLinkPrivate = false
      if(messageOk){
        this.canCreateMatch = true;
        return this.sendMatch(this.createMatchQuery);
      }
    }
  },
});
</script>
<style scoped>
:deep(input[type="checkbox"]) {
  -webkit-appearance: checkbox !important;
  -moz-appearance: checkbox !important;
  appearance: checkbox !important;
  background: initial !important;
  border: initial !important;
}
.reference-seach {
  box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(16px);
  height: 44px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid;
  border-radius: 24px;
  border-bottom-color: #264b67;
  border-left-color: #264b67;
  border-right-color: #076ae3;
  border-top-color: #264b67;
}
@media (min-width: 767px) {
  h1 {
    font-family: "Montserrat", sans-serif;
    font-size: 48px;
    font-weight: 600;
    line-height: 67px;
    letter-spacing: 0.04em;
    text-align: center;
    margin-top: 20px;
  }
}
@media (min-width: 767px) {
  .tabs li.image {
    background: rgba(255, 255, 255, 0.02);
    opacity: 0.8;
    box-shadow: inset 0px 0px 15px rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border-radius: 30px;
    width: 40px;
    height: 40px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

label {
  margin: 0px 0px 0px 8px;
}
.tabs li:first-child {
  margin-left: 0px;
}

.tabs li:hover {
  color: #ffffff;
}
.tabs li.image:hover svg path {
  fill: #999999;
}
footer {
  width: 90%;
  margin: 20px auto 0px auto;
  padding-bottom: 0px;
}
footer h3 {
  font-size: 48px;
  font-weight: 600;
}
footer h4 {
  font-size: 24px;
  font-weight: 500;
  line-height: 33.6px;
  display: inline-flex;
  max-width: 140px;
}
footer .open svg {
  position: relative;
  top: -39px;
  left: 145px;
}
.view-courts span {
  position: relative;
  top: 56px;
  left: 42px;
  font: 18px;
  font-weight: 600;
}
.all-tracks {
  width: 184px;
  height: 114px;
  background: #0458e2;
  border-radius: 12px;
}
.all-tracks a {
  position: relative;
  top: 45px;
  left: 40px;
  font: 18px;
  font-weight: 600;
}
input[type="checkbox"] {
  appearance: none;
  background-color: transparent;
  border: 1px solid #f3f3f34d;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  outline: none;
}

input[type="checkbox"].selected {
  box-sizing: border-box;
  position: relative;
  transform: scale(var(--ggs, 1));
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-radius: 100px;
}
input[type="checkbox"].selected::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 5px;
  top: 3px;
  width: 4px;
  height: 7px;
  border-width: 0 1px 1px 0;
  border-style: solid;
  transform-origin: bottom left;
  transform: rotate(45deg);
}
.select-date {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14.5px 142px;
  width: 100%;
  height: 48px;
  background: linear-gradient(
    103.18deg,
    var(--color1) -38.71%,
    var(--color2) 57.77%
  );
  box-shadow: -2px 4px 18px rgba(0, 15, 53, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 32px;
  margin-top: 24px;
}
.search-elements::-webkit-scrollbar {
  -webkit-appearance: none;
}

.search-elements {
  max-width: 1340px;
  gap: 16px;
  margin: 0px auto 20px auto;
  max-height: 63vh;
}

.search-image {
  background: linear-gradient(
    265.36deg,
    #0356e1 0.37%,
    #23edee 136.83%
  ) !important;
}
.wrapper-icon-home .container-custom-icon {
  border-radius: 50%;
}
.button-disabled {
  opacity: 0.5 !important;
  cursor: default !important;
}
.search-elements-container {
  overflow-y: scroll;
}
</style>